module.exports = __webpack_public_path__ + "static/media/IMG_9524.d033bc83.jpg";